import React from "react";
import { useLang, LANGUAGES } from "@/i18n";

export function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang } = useLang();
  const base =
    variant === "light"
      ? "bg-white/20 text-white backdrop-blur-md"
      : "bg-caneat-cream text-caneat-ink";
  return (
    <div className={`inline-flex items-center gap-0.5 rounded-full p-1 ${base}`} data-testid="language-switcher">
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`min-w-[38px] rounded-full px-2.5 py-1 text-xs font-bold tracking-wide transition-all ${
              active
                ? "bg-white text-caneat-orange shadow-sm"
                : variant === "light"
                ? "text-white/90 hover:bg-white/10"
                : "text-caneat-muted hover:bg-white/60"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
